module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "not-found"
    }
  }, [_vm._v("\n    404 - Page not found\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e71511e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = 462
// module chunks = 2